import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../../lib/api/client';

export function useVerifyEmail() {
  return useMutation({
    mutationFn: async (token: string) => {
      const response = await apiClient.post(`/auth/verify-email?token=${token}`);
      return response.data;
    },
  });
}
